<template>
    <div class="app_container">
        <el-form ref='form' :rules="rules" :model="form" label-width="80px" class="change-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="参数名">
                        <el-select ref='key' v-model="form.key" placeholder="请选择参数名">
                            <el-option v-for="item in key_list" :key="item.key" :label="item.cname" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="参数值" prop='value'>
                        <el-input type='textarea' v-show='flag' placeholder="请选择参数值" v-model="form.value"></el-input>

                        <el-radio-group v-show='!flag' v-model="form.value">
                            <el-radio :label="'1'">开</el-radio>
                            <el-radio :label="'0'">关</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type='primary' @click='SubmitFn("form")'>确定</el-button>
                        <el-button type='info' @click='onCancel'>取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import services from '../cicd.services'
    import { getRules } from '../cicd.rules'
    const rules = getRules()

    export default {
        props: {
            type: {
                type: String,
                default: 'add'
            },
            keys: String,
            values: String,
            envId: String,
            callback: Function,
            parentType: String
        },

        watch: {
            form: {
                handler(newVal) {
                    let Arr = this.keyList.filter(item => item.key === JSON.parse(newVal.key).key)
                    this.flag = !Arr[0].value
                },
                deep: true
            },
        },

        computed: {
            useParams() {
                return this.$store.state.useParams
            },
            keyList() {
                return this.useParams.key_list
            }
        },

        data() {
            return {
                form: {
                    key: '',
                    value: ''
                },
                flag: true,
                rules,
                key_list: []
            }
        },

        created() {
            if (this.type === 'edit') {
                this.$modal.title = '编辑参数'
                let key = JSON.parse(this.keys)
                key.value = key.value === '1' | key.value === '0' ? true : false
                key = JSON.stringify(key)
                this.form.key = key
                this.form.value = this.values
            }
            if (this.parentType === 'edit' && this.type === 'add') {
                this.getKeyList()
            } else {
                this.key_list = this.keyList.map(item => ({
                    key: JSON.stringify(item),
                    cname: item.cname,
                    value: item.value
                }))
            }
        },
        
        methods: {
            // 点击确定
            SubmitFn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = JSON.parse(this.form.key)
                        params.value = this.form.value
                        this.$modal.close()
                        this.callback(params, this.envId)
                    } else {
                        return false;
                    }
                });
            },

            // 点击取消
            onCancel() {
                this.$modal.close();
            },

            // 请求参数列表
            getKeyList() {
                // console.log(this.$route.params.id,1111111111111)
                let params = {
                    appId: this.$route.params.id,
                    envId: +this.envId
                }
                services.unusedParams(params)
                    .then(res => {
                        this.key_list = res.list.map(item => ({
                            key: JSON.stringify(item),
                            cname: item.cname,
                            value: item.value
                        }))
                    })
                    .catch(err => this.$message.error(err.message))
            }
        },

    }
</script>

<style>

</style>
